<ng-container *ngIf="code">
  <div class="flex items-center">
    <div [className]="'rex-language-switcher-toggler as-disabled'">
      <a3l-ui-flag [code]="code" class="rex-language-switcher-toggler__flag"></a3l-ui-flag>
      <div class="rex-language-switcher-toggler__code">{{ code }}</div>
    </div>
    <a3l-ui-helper-button *ngIf="tooltipActive" [class]="'ml-2'" [absolute]="false" [dialogClass]="LanguagesHelperDialog"></a3l-ui-helper-button>
  </div>
</ng-container>
